// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fa.fa-spinner.fa-spin {
  font-size: 1.32rem;
}

@media only screen and (max-width: 760px), (min-device-width: 768px) and (max-device-width: 1024px) {
  .formFooter .btn {
    font-size: 0.84em;
  }
  .fa.fa-spinner.fa-spin {
    font-size: inherit;
  }
}
.tab-content {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/system-common/step/step.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;;AACA;EACE;IACE,iBAAA;EAEF;EAAA;IACE,kBAAA;EAEF;AACF;AAAA;EACE,WAAA;AAEF","sourcesContent":[".fa.fa-spinner.fa-spin {\r\n  font-size: 1.32rem;\r\n}\r\n@media only screen and (max-width: 760px), (min-device-width: 768px) and (max-device-width: 1024px) {\r\n  .formFooter .btn {\r\n    font-size: 0.84em;\r\n  }\r\n  .fa.fa-spinner.fa-spin {\r\n    font-size: inherit;\r\n  }\r\n}\r\n.tab-content {\r\n  width: 100%;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
